import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useState } from "react";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { useHistory } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
FormControlLabel,
Checkbox,
Radio,
RadioGroup,
CircularProgress,
LinearProgress
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PrintIcon from "@mui/icons-material/Print";
import RelatorioEquipamentos from "./RelatorioEquipamentos";
import "./cadastroequipamentos.css";
import {
  collection,
  addDoc,
  getDocs,
  serverTimestamp
} from "firebase/firestore";
import { db, storage } from "../Config/firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, updateDoc } from "firebase/firestore";
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { consultaTenantAtual, aplicarTenantAtual, getUsuarioAtualComTenant } from "../Utils/tenant";
import { compressImage } from "../../utils/compressImage";
import "../Components/ListaMateriais/listaMateriais.css";

function getStatusVencimento(dataVencimento) {
  if (!dataVencimento) return "ok";

  const data =
    dataVencimento.toDate
      ? dataVencimento.toDate()
      : new Date(dataVencimento);

  if (isNaN(data)) return "ok";

  const hoje = new Date();
  const diffDias = Math.ceil(
    (data - hoje) / (1000 * 60 * 60 * 24)
  );

  if (diffDias < 0) return "vencido";
  if (diffDias <= 45) return "alerta";
  return "ok";
}

function normalizarImagensEquipamento(equipamento = {}) {
  const fonte = equipamento.imagensEquipamento || equipamento.ImagensEquipamento || [];
  if (!Array.isArray(fonte)) return [];

  return fonte
    .map((imagem, index) => ({
      ...imagem,
      id: imagem?.id || `imagem-${index + 1}`,
      nome: imagem?.nome || imagem?.name || `Imagem ${index + 1}`,
      url: imagem?.url || imagem?.downloadURL || "",
      path: imagem?.path || "",
    }))
    .filter((imagem) => Boolean(imagem.url));
}

function formatarDataEquipamento(valor) {
  if (!valor) return "";
  const data = valor.toDate ? valor.toDate() : new Date(valor);
  return Number.isNaN(data.getTime()) ? "" : data.toLocaleDateString("pt-BR");
}

function rotuloSituacaoEquipamento(equipamento) {
  if (equipamento.status === "descartado") {
    return `Equipamento descartado${equipamento.motivoDescarte ? `: ${equipamento.motivoDescarte}` : ""}`;
  }
  if (equipamento.status === "inativo") return "Equipamento inativo";
  if (equipamento.status === "nao_obrigatorio") return "Documentação não obrigatória (Locação)";
  if (equipamento.status === "vencido") return "Certificação vencida";
  if (equipamento.status === "nao_aplicavel") return "Equipamento sem calibração";
  if (equipamento.status === "alerta") return "Certificação a vencer";
  return "Documentação em dia";
}

function corSituacaoEquipamento(equipamento) {
  if (equipamento.status === "descartado" || equipamento.status === "vencido") return "#d32f2f";
  if (equipamento.status === "inativo") return "#64748b";
  if (equipamento.status === "alerta") return "#b7791f";
  if (equipamento.status === "nao_obrigatorio" || equipamento.status === "nao_aplicavel") return "#1976d2";
  return "#2e7d32";
}

function calcularStatusEquipamento(
  documentos,
  tipos,
  equipamento,
) {
  if (equipamento.statusEquipamento === "descartado") return "descartado";
  if (!equipamento.ativo) return "inativo";

  if (!equipamento.calibravel) return "nao_aplicavel";

  if (equipamento.tipoUso === "locacao")
    return "nao_obrigatorio";

  // filtra tipos obrigatórios aplicáveis ao equipamento
  const obrigatorios = tipos.filter(t => {
    if (!t.obrigatorio) return false;

    if (!t.escopo) return true;

    if (t.escopo === "geral") return true;

    if (
      t.escopo === "especifico" &&
      t.equipamentoId === equipamento.id
    )
      return true;

    return false;
  });

  if (obrigatorios.length === 0) return "ok";

  let temAlerta = false;

  for (const tipo of obrigatorios) {
    const doc = documentos.find(
      d =>
        d.tipoDocumentoCodigo === tipo.codigo &&
        (d.statusDocumento === "ENVIADO" ||
          d.statusDocumento === "DISPENSADO")
    );

    if (!doc) return "vencido";

    if (doc.statusDocumento === "DISPENSADO")
      continue;

    if (tipo.temVencimento) {
      const status = getStatusVencimento(
        doc.dataVencimento
      );

      if (status === "vencido") return "vencido";
      if (status === "alerta") temAlerta = true;
    }
  }

  return temAlerta ? "alerta" : "ok";
}



export default function CadastroEquipamentos() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
  const history = useHistory();

    const auth = getAuth();
    const [authReady, setAuthReady] = useState(false);

  const [equipamentos, setEquipamentos] = useState([]);
  const [carregandoEquipamentos, setCarregandoEquipamentos] = useState(true);
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("todos");
  const [dialogEquipamento, setDialogEquipamento] = useState(false);
  const [dialogRelatorio, setDialogRelatorio] = useState(false);
  const [relatorioAberto, setRelatorioAberto] = useState(null);
  const [tipoRelatorio, setTipoRelatorio] = useState("calibracoes");
  const [filtroRelatorio, setFiltroRelatorio] = useState("todos");
  const [vencimentoAte, setVencimentoAte] = useState("");
  const [equipamentosSelecionadosRelatorio, setEquipamentosSelecionadosRelatorio] = useState([]);
  const [imagensEquipamento, setImagensEquipamento] = useState([]);
  const [imagensRemovidas, setImagensRemovidas] = useState([]);
  const [progressoImagens, setProgressoImagens] = useState(0);
  const [imagensVisualizacao, setImagensVisualizacao] = useState([]);
  const [dialogImagens, setDialogImagens] = useState(false);

const [modoEdicao, setModoEdicao] = useState(false);
const [equipamentoEditandoId, setEquipamentoEditandoId] = useState(null);

  

  const [novoEquipamento, setNovoEquipamento] = useState({
  nome: "",
  descricao: "",
  numeroPatrimonio: "",
  tipoUso: "interno",
  calibravel: true,
  celulaCargaPrensa: false,
  ativo: true,
  statusEquipamento: "ativo",
  motivoDescarte: "",
  locado: false,
  locacao: {
    cliente: "",
    endereco: "",
    contato: "",
    dataInicio: "",
    periodo: ""
  }
});

function abrirEditarEquipamento(eq) {
  setModoEdicao(true);
  setEquipamentoEditandoId(eq.id);

  setNovoEquipamento({
    nome: eq.nome || "",
    descricao: eq.descricao || "",
    numeroPatrimonio: eq.numeroPatrimonio || "",
    tipoUso: eq.tipoUso || "interno",
    calibravel: eq.calibravel ?? true,
    celulaCargaPrensa: eq.celulaCargaPrensa ?? false,
    ativo: eq.ativo ?? true,
    statusEquipamento: eq.statusEquipamento || (eq.ativo === false ? "inativo" : "ativo"),
    motivoDescarte: eq.motivoDescarte || "",
    locado: eq.locado ?? false,
    locacao: eq.locacao || {
      cliente: "",
      endereco: "",
      contato: "",
      dataInicio: "",
      periodo: "",
      celulaCargaPrensa: false,
    }
  });

  setImagensEquipamento(normalizarImagensEquipamento(eq));
  setImagensRemovidas([]);
  setProgressoImagens(0);

  setDialogEquipamento(true);
}

function abrirImagensEquipamento(eq) {
  setImagensVisualizacao(normalizarImagensEquipamento(eq));
  setDialogImagens(true);
}


  
  useEffect(() => {
  const unsub = onAuthStateChanged(auth, user => {
    setAuthReady(true);
  });
  return unsub;
}, [auth]);


  useEffect(() => {
    carregarEquipamentos();
  }, []);

  async function carregarEquipamentos() {
  setCarregandoEquipamentos(true);
  try {
  const eqSnap = await getDocs(consultaTenantAtual(collection(db, "equipamentos")));
  const docSnap = await getDocs(consultaTenantAtual(collection(db, "eq_documentos")));
  const tiposSnap = await getDocs(consultaTenantAtual(collection(db, "eq_tipos_documentos")));


  const docsPorEquipamento = {};

  docSnap.docs.forEach(d => {
    const data = d.data();
    if (!docsPorEquipamento[data.equipamentoId]) {
      docsPorEquipamento[data.equipamentoId] = [];
    }
    docsPorEquipamento[data.equipamentoId].push(data);
  });
  const tiposCarregados = tiposSnap.docs.map(d => ({
    id: d.id,
    ...d.data()
  }));

  // Evita considerar o mesmo tipo de documento mais de uma vez.
  // Se houver um tipo geral e outro específico com o mesmo nome,
  // o específico será usado somente no equipamento ao qual pertence.
  const tipos = tiposCarregados.filter((tipo, index, lista) => {
    const normalizarNome = (valor) =>
      String(valor || "")
        .trim()
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

    const chaveAtual = normalizarNome(tipo.nome);

    const duplicados = lista.filter(
      outro => normalizarNome(outro.nome) === chaveAtual
    );

    if (duplicados.length <= 1) return true;

    if (tipo.escopo === "especifico") return true;

    const existeEspecifico = duplicados.some(
      outro => outro.escopo === "especifico"
    );

    return !existeEspecifico && lista.findIndex(
      outro => normalizarNome(outro.nome) === chaveAtual
    ) === index;
  });

  const codigosCertificadoCalibracao = new Set(
    tipos
      .filter(tipo => {
        const identificacao = `${tipo.nome || ""} ${tipo.codigo || ""}`
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase();

        return tipo.temVencimento && identificacao.includes("CERTIFICADO");
      })
      .map(tipo => tipo.codigo)
  );
  codigosCertificadoCalibracao.add("CERTIFICADO");


  const lista = eqSnap.docs.map(d => {
    const equipamento = { id: d.id, ...d.data() };
    
    const documentos = docsPorEquipamento[equipamento.id] || [];
    const certificadoAtivo = documentos.find(
      d =>
        codigosCertificadoCalibracao.has(d.tipoDocumentoCodigo) &&
        d.statusDocumento === "ENVIADO" &&
        d.dataVencimento
    ) || null;


   return {
  ...equipamento,
  status: calcularStatusEquipamento(
  documentos,
  tipos,
  equipamento
),

  certificado: certificadoAtivo
};

  });

  setEquipamentos(lista);
  } finally {
    setCarregandoEquipamentos(false);
  }
}

  function selecionarImagensEquipamento(event) {
    const arquivos = Array.from(event.target.files || []).filter((arquivo) =>
      arquivo.type.startsWith("image/")
    );
    if (!arquivos.length) return;

    setImagensEquipamento((atuais) => [
      ...atuais,
      ...arquivos.map((arquivo, index) => ({
        id: `nova-${Date.now()}-${index}`,
        arquivo,
        nome: arquivo.name,
        previewUrl: URL.createObjectURL(arquivo),
      })),
    ]);
    event.target.value = "";
  }

  function removerImagemEquipamento(index) {
    const imagem = imagensEquipamento[index];
    if (imagem?.path) setImagensRemovidas((paths) => [...paths, imagem.path]);
    if (imagem?.previewUrl) URL.revokeObjectURL(imagem.previewUrl);
    setImagensEquipamento((atuais) =>
      atuais.filter((_, itemIndex) => itemIndex !== index)
    );
  }

  async function enviarImagensEquipamento(equipamentoId, tenantId) {
    const novas = imagensEquipamento.filter((imagem) => imagem.arquivo);
    const finais = [];
    let concluidas = 0;

    for (let index = 0; index < imagensEquipamento.length; index += 1) {
      const imagem = imagensEquipamento[index];
      if (!imagem.arquivo) {
        finais.push({
          id: imagem.id || `imagem-${index + 1}`,
          nome: imagem.nome || "",
          path: imagem.path || "",
          url: imagem.url || "",
        });
        continue;
      }

      const comprimida = await compressImage(imagem.arquivo, {
        maxWidth: 1600,
        maxHeight: 1600,
        quality: 0.78,
      });
      const idImagem = `imagem-${Date.now()}-${index + 1}`;
      const path = `tenants/${tenantId}/equipamentos/${equipamentoId}/imagens/${idImagem}.jpg`;
      const storageRef = ref(storage, path);

      await new Promise((resolve, reject) => {
        const tarefa = uploadBytesResumable(storageRef, comprimida, {
          contentType: "image/jpeg",
        });
        tarefa.on("state_changed", (snapshot) => {
          const fracao = snapshot.totalBytes
            ? snapshot.bytesTransferred / snapshot.totalBytes
            : 0;
          setProgressoImagens(
            Math.round(((concluidas + fracao) / Math.max(1, novas.length)) * 100)
          );
        }, reject, resolve);
      });

      finais.push({
        id: idImagem,
        nome: imagem.nome || imagem.arquivo.name,
        path,
        url: await getDownloadURL(storageRef),
      });
      concluidas += 1;
      setProgressoImagens(
        Math.round((concluidas / Math.max(1, novas.length)) * 100)
      );
    }

    return finais;
  }

  async function excluirImagensRemovidas() {
    await Promise.all(
      imagensRemovidas.map((path) => deleteObject(ref(storage, path)).catch(() => {}))
    );
  }


  async function salvarEquipamento() {
  if (!novoEquipamento.nome) return;
  if (
    novoEquipamento.statusEquipamento === "descartado" &&
    !novoEquipamento.motivoDescarte.trim()
  ) {
    alert("Informe o motivo do descarte.");
    return;
  }

  const userData = await getUsuarioAtualComTenant();
  if (!userData?.tenantId) {
    throw new Error("Usuário sem tenantId para salvar as imagens do equipamento.");
  }
  setProgressoImagens(0);

          const payload = {
  nome: novoEquipamento.nome,
  descricao: novoEquipamento.descricao,
  numeroPatrimonio: novoEquipamento.numeroPatrimonio.trim(),
  tipoUso: novoEquipamento.tipoUso,
  calibravel: novoEquipamento.calibravel,
  celulaCargaPrensa: novoEquipamento.celulaCargaPrensa,
  ativo: novoEquipamento.ativo,
  statusEquipamento: novoEquipamento.statusEquipamento,
  motivoDescarte: novoEquipamento.statusEquipamento === "descartado"
    ? novoEquipamento.motivoDescarte.trim()
    : "",
  locado: novoEquipamento.locado,
  locacao:
    novoEquipamento.tipoUso === "locacao" && novoEquipamento.locado
      ? novoEquipamento.locacao
      : null
};


  if (modoEdicao && equipamentoEditandoId) {
    const imagensFinais = await enviarImagensEquipamento(
      equipamentoEditandoId,
      userData.tenantId
    );
    await updateDoc(
      doc(db, "equipamentos", equipamentoEditandoId),
      { ...payload, imagensEquipamento: imagensFinais }
    );
    await excluirImagensRemovidas();
  } else {
    const equipamentoRef = await addDoc(collection(db, "equipamentos"), aplicarTenantAtual({
      ...payload,
      imagensEquipamento: [],
      createdAt: serverTimestamp()
    }));
    const imagensFinais = await enviarImagensEquipamento(
      equipamentoRef.id,
      userData.tenantId
    );
    if (imagensFinais.length > 0) {
      await updateDoc(equipamentoRef, { imagensEquipamento: imagensFinais });
    }
  }

  // RESET GERAL
  setDialogEquipamento(false);
  setModoEdicao(false);
  setEquipamentoEditandoId(null);

  setNovoEquipamento({
  nome: "",
  descricao: "",
  numeroPatrimonio: "",
  tipoUso: "interno",
  calibravel: true,
  celulaCargaPrensa: false,
  ativo: true,
  statusEquipamento: "ativo",
  motivoDescarte: "",
  locado: false,
  locacao: {
    cliente: "",
    endereco: "",
    contato: "",
    dataInicio: "",
    periodo: ""
  }
});
  setImagensEquipamento([]);
  setImagensRemovidas([]);
  setProgressoImagens(0);


  carregarEquipamentos();
}


        const equipamentosFiltrados = equipamentos
        .filter(e =>
          contemTextoPesquisa(
            `${e.nome || ""} ${e.numeroPatrimonio || ""} ${
              e.certificado
                ? e.certificado.numeroCertificado || "Certificado enviado"
                : ""
            } ${formatarDataEquipamento(e.certificado?.dataVencimento)}`.toLowerCase(),
            filtroNome.toLowerCase()
          )
        )
        .filter(e => {
              if (filtroStatus === "todos") return true;

              if (filtroStatus === "locado") {
                return e.locado === true;
              }

              if (filtroStatus === "itens_locacao") {
                return e.tipoUso === "locacao";
              }

              return e.status === filtroStatus;
            })

        .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
  function formularioInvalido() {
  if (!novoEquipamento.nome) return true;
  if (!novoEquipamento.tipoUso) return true;
  if (novoEquipamento.calibravel === undefined) return true;
  if (novoEquipamento.ativo === undefined) return true;

  if (
    novoEquipamento.tipoUso === "locacao" &&
    novoEquipamento.locado === true
  ) {
    const loc = novoEquipamento.locacao;
    if (!loc.cliente || !loc.dataInicio) return true;
  }

  return false;
}

  function obterEquipamentosRelatorio() {
    const limite = vencimentoAte ? new Date(`${vencimentoAte}T23:59:59`) : null;
    return equipamentos
      .filter((equipamento) => {
        if (filtroRelatorio === "todos") return true;
        const valor = equipamento.certificado?.dataVencimento;
        const data = valor?.toDate?.() || (valor ? new Date(valor) : null);
        return limite && data && !Number.isNaN(data.getTime()) && data <= limite;
      })
      .sort((a, b) => String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR"));
  }

  function abrirDialogRelatorio() {
    setEquipamentosSelecionadosRelatorio(equipamentos.map((equipamento) => equipamento.id));
    setDialogRelatorio(true);
  }

  function abrirRelatorio() {
    const selecionados = obterEquipamentosRelatorio()
      .filter((equipamento) => equipamentosSelecionadosRelatorio.includes(equipamento.id));
    setRelatorioAberto({ tipo: tipoRelatorio, equipamentos: selecionados });
    setDialogRelatorio(false);
  }

  const equipamentosDisponiveisRelatorio = obterEquipamentosRelatorio();

  if (relatorioAberto) {
    return (
      <RelatorioEquipamentos
        tipo={relatorioAberto.tipo}
        equipamentos={relatorioAberto.equipamentos}
        onVoltar={() => setRelatorioAberto(null)}
      />
    );
  }


  return (
    <Box>
      <Navbar />

      <Box p={3}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h4" mb={3}>
          Cadastro de Equipamentos
        </Typography>
            <Box
              sx={{
                mb: 3,
                display: "flex",
                alignItems: "center",
                gap: 2,
                flexWrap: "nowrap"
              }}
            >

        <Button
                variant="contained"
                startIcon={<AddIcon />}
                size="small"
                sx={{
                  height: 40,
                  px: 2.5,
                  whiteSpace: "nowrap"
                }}
               onClick={() => {
  setModoEdicao(false);
  setEquipamentoEditandoId(null);
  setNovoEquipamento({
  nome: "",
  descricao: "",
  numeroPatrimonio: "",
  tipoUso: "interno",
  calibravel: true,
  celulaCargaPrensa: false,
  ativo: true,
  statusEquipamento: "ativo",
  motivoDescarte: "",
  locado: false,
  locacao: {
    cliente: "",
    endereco: "",
    contato: "",
    dataInicio: "",
    periodo: ""
  }
});
  setImagensEquipamento([]);
  setImagensRemovidas([]);
  setProgressoImagens(0);
  setDialogEquipamento(true);
}}


              >
                Novo Equipamento
            </Button>

            <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              size="small"
              sx={{ height: 40, px: 2.5, whiteSpace: "nowrap" }}
              onClick={abrirDialogRelatorio}
            >
              Relatório
            </Button>


            <TextField
                  label="Pesquisar equipamento"
                  size="small"
                  value={filtroNome}
                  onChange={e => setFiltroNome(e.target.value)}
                  sx={{ flexGrow: 1 }}
            />



              <Box sx={{ width: 220 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                      value={filtroStatus}
                      label="Status"
                      onChange={e => setFiltroStatus(e.target.value)}
                    >
                      <MenuItem value="todos">Todos</MenuItem>
                      <MenuItem value="descartado">🗑 Descartado</MenuItem>
                      <MenuItem value="inativo">⏸ Inativo</MenuItem>
                      <MenuItem value="nao_obrigatorio">ℹ️ Não obrigatório (Locação)</MenuItem>
                      <MenuItem value="vencido">❌ Certificação vencida</MenuItem>
                      <MenuItem value="alerta">⚠️ Certificação a vencer</MenuItem>
                      <MenuItem value="ok">✅ Em dia</MenuItem>

                      <MenuItem value="itens_locacao">🧰 Itens para locação</MenuItem>
                      <MenuItem value="locado">📦 Locados</MenuItem>
                    </Select>


              </FormControl>
            </Box>

</Box>
        </Paper>

        <Dialog open={dialogRelatorio} onClose={() => setDialogRelatorio(false)} fullWidth maxWidth="sm">
          <DialogTitle>Relatório de equipamentos</DialogTitle>
          <DialogContent dividers>
            <Stack spacing={3} sx={{ pt: 1 }}>
              <FormControl>
                <Typography fontWeight={600} mb={1}>Tipo de relatório</Typography>
                <RadioGroup value={tipoRelatorio} onChange={(e) => setTipoRelatorio(e.target.value)}>
                  <FormControlLabel value="calibracoes" control={<Radio />} label="Equipamentos e calibrações" />
                  <FormControlLabel value="envio_calibracao" control={<Radio />} label="Equipamentos para envio à calibração" />
                </RadioGroup>
              </FormControl>

              <FormControl>
                <Typography fontWeight={600} mb={1}>Equipamentos</Typography>
                <RadioGroup value={filtroRelatorio} onChange={(e) => setFiltroRelatorio(e.target.value)}>
                  <FormControlLabel value="todos" control={<Radio />} label="Todos os equipamentos" />
                  <FormControlLabel value="vencimento" control={<Radio />} label="Com calibração vencendo até" />
                </RadioGroup>
              </FormControl>

              {filtroRelatorio === "vencimento" && (
                <TextField
                  label="Vencimento até"
                  type="date"
                  value={vencimentoAte}
                  onChange={(e) => setVencimentoAte(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              )}

              <FormControl>
                <Typography fontWeight={600} mb={1}>Itens incluídos no relatório</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        equipamentosDisponiveisRelatorio.length > 0 &&
                        equipamentosDisponiveisRelatorio.every((equipamento) =>
                          equipamentosSelecionadosRelatorio.includes(equipamento.id)
                        )
                      }
                      indeterminate={
                        equipamentosDisponiveisRelatorio.some((equipamento) =>
                          equipamentosSelecionadosRelatorio.includes(equipamento.id)
                        ) &&
                        !equipamentosDisponiveisRelatorio.every((equipamento) =>
                          equipamentosSelecionadosRelatorio.includes(equipamento.id)
                        )
                      }
                      onChange={(e) => {
                        const idsDisponiveis = equipamentosDisponiveisRelatorio.map((equipamento) => equipamento.id);
                        setEquipamentosSelecionadosRelatorio((atuais) =>
                          e.target.checked
                            ? [...new Set([...atuais, ...idsDisponiveis])]
                            : atuais.filter((id) => !idsDisponiveis.includes(id))
                        );
                      }}
                    />
                  }
                  label="Selecionar todos"
                />
                <Paper variant="outlined" sx={{ maxHeight: 220, overflowY: "auto", px: 1 }}>
                  {equipamentosDisponiveisRelatorio.map((equipamento) => (
                    <FormControlLabel
                      key={equipamento.id}
                      sx={{ display: "flex", m: 0 }}
                      control={
                        <Checkbox
                          checked={equipamentosSelecionadosRelatorio.includes(equipamento.id)}
                          onChange={(e) =>
                            setEquipamentosSelecionadosRelatorio((atuais) =>
                              e.target.checked
                                ? [...atuais, equipamento.id]
                                : atuais.filter((id) => id !== equipamento.id)
                            )
                          }
                        />
                      }
                      label={equipamento.nome || "Equipamento sem nome"}
                    />
                  ))}
                  {!equipamentosDisponiveisRelatorio.length && (
                    <Typography color="text.secondary" sx={{ p: 1 }}>
                      Nenhum equipamento encontrado para o filtro selecionado.
                    </Typography>
                  )}
                </Paper>
              </FormControl>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogRelatorio(false)}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={abrirRelatorio}
              disabled={
                (filtroRelatorio === "vencimento" && !vencimentoAte) ||
                !equipamentosDisponiveisRelatorio.some((equipamento) =>
                  equipamentosSelecionadosRelatorio.includes(equipamento.id)
                )
              }
            >
              Gerar relatório
            </Button>
          </DialogActions>
        </Dialog>



        {carregandoEquipamentos && (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}>
            <CircularProgress />
            <Typography color="text.secondary">Carregando equipamentos...</Typography>
          </Box>
        )}

        {!carregandoEquipamentos && equipamentosFiltrados.length > 0 && (
          <Paper sx={{ height: "calc(100vh - 230px)", overflow: "auto" }}>
            <Box
              component="table"
              className="table table-hover cadastro-tabela lista-cadastro-padrao"
              sx={{
                minWidth: 1050,
                "& tbody tr": { cursor: "pointer" },
              }}
            >
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Descrição</th>
                  <th>Patrimônio</th>
                  <th>Tipo</th>
                  <th>Locado</th>
                  <th>Certificado</th>
                  <th>Imagem</th>
                  <th>Situação</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {equipamentosFiltrados.map((eq) => {
                  const imagens = normalizarImagensEquipamento(eq);
                  return (
                    <tr key={eq.id} onClick={() => history.push(`/app/cadastro-equipamento/${eq.id}`)}>
                      <td className="lista-dado-principal">{eq.nome || "-"}</td>
                      <td className="lista-dado-secundario">{eq.descricao || "-"}</td>
                      <td className="lista-dado-secundario">{eq.numeroPatrimonio || "-"}</td>
                      <td className="lista-dado-rotulo">{eq.tipoUso === "locacao" ? "Locação" : "Uso interno"}</td>
                      <td className={`lista-dado-rotulo ${eq.locado === true ? "equipamento-locado" : ""}`}>
                        {eq.locado === true ? "Sim" : "Não"}
                      </td>
                      <td className="lista-dado-destaque">
                        {eq.certificado ? (
                          <Box sx={{ color: getStatusVencimento(eq.certificado.dataVencimento) === "vencido" ? "#d32f2f" : getStatusVencimento(eq.certificado.dataVencimento) === "alerta" ? "#b7791f" : "#2e7d32" }}>
                            <div>{eq.certificado.numeroCertificado || "Certificado enviado"}</div>
                            {eq.certificado.dataVencimento && <div>{getStatusVencimento(eq.certificado.dataVencimento) === "vencido" ? "Vencido em" : "Vence em"} {formatarDataEquipamento(eq.certificado.dataVencimento)}</div>}
                          </Box>
                        ) : "-"}
                      </td>
                      <td>
                        {imagens.length > 0 ? (
                          <Button size="small" variant="outlined" onClick={(e) => { e.stopPropagation(); abrirImagensEquipamento(eq); }}>
                            Visualizar
                          </Button>
                        ) : "-"}
                      </td>
                      <td>
                        <Typography fontSize={13} fontWeight={600} sx={{ color: corSituacaoEquipamento(eq) }}>
                          {rotuloSituacaoEquipamento(eq)}
                        </Typography>
                      </td>
                      <td className="col-acao">
                        <i
                          className="fas fa-edit icone-acao"
                          title="Editar"
                          onClick={(e) => { e.stopPropagation(); abrirEditarEquipamento(eq); }}
                        />
                        <span onClick={(e) => e.stopPropagation()}>
                          <HistoricoCadastro colecao="equipamentos" documentoId={eq.id} registro={eq} />
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Box>
          </Paper>
        )}
        {!carregandoEquipamentos && equipamentosFiltrados.length === 0 && (
          <Typography align="center" color="text.secondary" py={4}>
            Nenhum equipamento cadastrado.
          </Typography>
        )}
                              </Box>

      <Dialog open={dialogImagens} onClose={() => setDialogImagens(false)} fullWidth maxWidth="md">
        <DialogTitle>Imagens do equipamento</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" }, gap: 2 }}>
            {imagensVisualizacao.map((imagem, index) => (
              <Box
                component="img"
                key={imagem.id || index}
                src={imagem.url}
                alt={imagem.nome || `Imagem ${index + 1}`}
                sx={{ width: "100%", maxHeight: 420, objectFit: "contain", bgcolor: "#f8fafc" }}
              />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogImagens(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG */}
      <Dialog
        open={dialogEquipamento}
        onClose={() => !salvandoCadastro && setDialogEquipamento(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Novo Equipamento</DialogTitle>

  <DialogContent>

  {/* NOME */}
  <TextField
  label="Nome do Equipamento"
  fullWidth
  margin="dense"
  value={novoEquipamento.nome}
  onChange={e =>
    setNovoEquipamento({
      ...novoEquipamento,
      nome: e.target.value
    })
  }
/>


  {/* DESCRIÇÃO */}
  <TextField
    label="Descrição"
    fullWidth
    margin="dense"
    value={novoEquipamento.descricao}
    onChange={e =>
      setNovoEquipamento({
        ...novoEquipamento,
        descricao: e.target.value
      })
    }
  />

  <TextField
    label="Número de patrimônio"
    fullWidth
    margin="dense"
    value={novoEquipamento.numeroPatrimonio}
    onChange={e =>
      setNovoEquipamento({
        ...novoEquipamento,
        numeroPatrimonio: e.target.value
      })
    }
  />

  <Box sx={{ mt: 1.5, mb: 1 }}>
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
      <Button component="label" variant="outlined" disabled={salvandoCadastro}>
        Adicionar imagens
        <input hidden type="file" accept="image/*" multiple onChange={selecionarImagensEquipamento} />
      </Button>
      <Typography variant="body2" color="text.secondary">
        {imagensEquipamento.length
          ? `${imagensEquipamento.length} imagem(ns) selecionada(s)`
          : "Nenhuma imagem selecionada"}
      </Typography>
    </Stack>

    {imagensEquipamento.length > 0 && (
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: 1.5, mt: 1.5 }}>
        {imagensEquipamento.map((imagem, index) => (
          <Paper key={imagem.id || index} variant="outlined" sx={{ p: 1 }}>
            <Box
              component="img"
              src={imagem.previewUrl || imagem.url}
              alt={imagem.nome || `Imagem ${index + 1}`}
              sx={{ width: "100%", height: 130, objectFit: "contain", bgcolor: "#f8fafc" }}
            />
            <Button
              size="small"
              color="error"
              onClick={() => removerImagemEquipamento(index)}
              disabled={salvandoCadastro}
              sx={{ mt: 0.5 }}
            >
              Remover
            </Button>
          </Paper>
        ))}
      </Box>
    )}

    {salvandoCadastro && imagensEquipamento.some((imagem) => imagem.arquivo) && (
      <Box sx={{ mt: 1.5 }}>
        <LinearProgress variant="determinate" value={progressoImagens} />
        <Typography variant="caption" color="text.secondary">
          Salvando imagens... {progressoImagens}%
        </Typography>
      </Box>
    )}
  </Box>

  {/* TIPO DE EQUIPAMENTO */}
  <FormControl fullWidth margin="dense">
    <InputLabel>Tipo de Equipamento</InputLabel>
    <Select
      value={novoEquipamento.tipoUso}
      label="Tipo de Equipamento"
      onChange={e =>
        setNovoEquipamento({
          ...novoEquipamento,
          tipoUso: e.target.value,
          ativo:true,
          statusEquipamento: "ativo",
          motivoDescarte: "",
          locado: false,
          locacao: {
            cliente: "",
            endereco: "",
            contato: "",
            dataInicio: "",
            periodo: ""
          }
        })
      }
    >
      <MenuItem value="interno">Uso interno</MenuItem>
      <MenuItem value="locacao">Locação</MenuItem>
    </Select>
  </FormControl>

  <FormControl fullWidth margin="dense">
  <InputLabel>Possui calibração?</InputLabel>
  <Select
  value={novoEquipamento.calibravel ?? true}
  label="Possui calibração?"
  onChange={e =>
    setNovoEquipamento({
      ...novoEquipamento,
      calibravel: e.target.value
    })
  }
>



    <MenuItem value={true}>Sim, possui calibração</MenuItem>
    <MenuItem value={false}>Não possui calibração</MenuItem>
  </Select>
</FormControl>


<FormControlLabel
  control={
    <Checkbox
      checked={novoEquipamento.celulaCargaPrensa === true}
      onChange={e =>
        setNovoEquipamento({
          ...novoEquipamento,
          celulaCargaPrensa: e.target.checked
        })
      }
    />
  }
  label="Célula de carga / Prensa"
/>

    <FormControl fullWidth margin="dense">
            <InputLabel>Status do Equipamento</InputLabel>
            <Select
              value={novoEquipamento.statusEquipamento}
              label="Status do Equipamento"
              onChange={e =>
                setNovoEquipamento({
                  ...novoEquipamento,
                  statusEquipamento: e.target.value,
                  ativo: e.target.value === "ativo",
                  motivoDescarte: e.target.value === "descartado"
                    ? novoEquipamento.motivoDescarte
                    : ""
                })
              }
  >
    <MenuItem value="ativo">Ativo</MenuItem>
    <MenuItem value="inativo">Inativo</MenuItem>
    <MenuItem value="descartado">Descartado</MenuItem>
  </Select>
</FormControl>

{novoEquipamento.statusEquipamento === "descartado" && (
  <TextField
    label="Motivo do descarte"
    fullWidth
    required
    multiline
    minRows={2}
    margin="dense"
    value={novoEquipamento.motivoDescarte}
    onChange={e =>
      setNovoEquipamento({
        ...novoEquipamento,
        motivoDescarte: e.target.value
      })
    }
  />
)}

</DialogContent>


        <DialogActions>
          
          <Button
  variant="contained"
  onClick={() => executarSalvamento(salvarEquipamento)}
  disabled={formularioInvalido() || salvandoCadastro}
>
  {salvandoCadastro ? "Salvando..." : "Salvar"}
</Button>

        </DialogActions>
      </Dialog>
    </Box>
  );
}
